var app = angular.module("leonardo");

var UnitTypeList = function($scope, $rootScope, $q, ngDialog, $filter, UnitTypeService, PermissionService,
                            FilterService, $controller) {

  $scope.permissionService = PermissionService;
  $scope.units_types = [];

  $scope.showUnitTypeDeleteDialog = function(unit_type){
    UnitTypeService.get(unit_type.id).then(function(data) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/unit/delete-unit-type.html',
        className: 'ngdialog-theme-default ngdialog-delete-unit-type',
        controller: 'DeleteUnitTypeDialog',
        data: {
          unit_type: data
        }
      }).then(function(resp){
        UnitTypeService.updateCollection(resp, true);
        $scope.loadPage($scope.page);
      });
    });
  };

  $scope.showUnitTypeEditDialog = function(unit_type){
    ngDialog.open({
      template: 'views/templates/dialog/unit/unit-type-form.html',
      controller: 'UnitTypeForm',
      data: {
        mode: 'edit',
        unit_type: unit_type
      }
    });
  };

  $scope.getEntitiesPromise = function(options) {
    var defer = $q.defer();
    options['summary'] = true;
    if (FilterService.getFilter('account_reports')) {
      options.account = FilterService.getFilter('account_reports');
    }
    if (FilterService.getFilter('type_name')) {
      options.search = FilterService.getFilter('type_name');
    }
    UnitTypeService.getlist(options).then(function (list) {
      $scope.units_types = list.results ? list.results : list;
      defer.resolve(list);
    }, function(error){
      defer.reject(error);
    });
    return defer.promise;
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.$on('unit_type:updated', function() {
    $scope.loadPage(1);
  });
  $scope.$on('unit_type:created', function() {
    $scope.loadPage(1);
  });

  $scope.loadPage(1);

};

app.controller('UnitTypeList', ['$scope', '$rootScope', '$q', 'ngDialog', '$filter', 'UnitTypeService',
  'PermissionService', 'FilterService', '$controller', UnitTypeList]);
